import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReportsComponent } from './reports.component';
import { EmbedReportComponent } from './embed-report/embed-report.component';
import { PowerbiAutologinComponent } from './powerbi-autologin/powerbi-autologin.component';
import { DynamicReportComponent } from './dynamic-report/dynamic-report.component';
import { InbuiltReportV2Component } from './inbuilt-report-v2/inbuilt-report-v2/inbuilt-report-v2.component';
const routes: Routes = [
  { path: '', component: ReportsComponent },
  { path: 'powerbi-report', component: PowerbiAutologinComponent },
  { path: 'dynamic-report/:ReportName', component: DynamicReportComponent },
  { path: 'inbuilt-report', component: InbuiltReportV2Component },
  { path: '**', component: EmbedReportComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportRoutingModule { }
